<template>
  <div class="resize">
    <slot />
  </div>
</template>

<style scoped lang="scss">
$design-width: 1200;
$default-size: 16;
$min-width: 1000px;

.resize {
  @include media-breakpoint-down(lg) {
    font-size: calc($default-size * max($min-width, 100vw) / $design-width);
  }

  @include media-breakpoint-down(md) {
    font-size: em($default-size);
  }
}
</style>
